import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
const INITIAL_STATE = {
  'data': {},
  'loading': false,
};
export const waitHappyVehicleDetail = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_DETAIL_WAIT_HAPPY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_DETAIL_WAIT_HAPPY]: (state, action) => ({
      ...state,
      'loading': false,
      'data': action.response.data[0],
    }),
    [ActionTypes.FETCHED_DETAIL_WAIT_HAPPY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'data': {},
    }),
  })(state, action);
};
